import React, {Component} from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import FontAwesome from 'react-fontawesome';

export default class VisitorLocationReport extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.dataURL = `visitorLocation/${props.expoID}/${props.showID}`;
    this.state = {locations: []}
  }
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'locations');
  }
  componentWillUnmount() {
    this.unbind('locations');
  }
  getCSVData = () => {
    return this.state.locations;
  }
  render() {
    const columns = [
      {Header: 'City', accessor: 'city', aggregate: (values, rows) => values[0]},
      {Header: 'Region', accessor: 'region', aggregate: (values, rows) => values[0]},
      {Header: 'Country', accessor: 'country', aggregate: (values, rows) => values[0]},
      {Header: 'Postal Code', accessor: 'postal'},
      {Header: 'Visitors', accessor: 'ip', aggregate: (values, rows) => values.length}
    ]
    const filename = this.props.name.replace(/\s+/g, '_');
    const csvData = this.state.locations.map((loc) => ({
      city: loc.city,
      country: loc.country,
      hostname: loc.hostname,
      ip: loc.ip,
      loc: loc.loc,
      postal: loc.postal,
      region: loc.region
    }));
    return (
      <div>
        <p className="info-panel">
          The following table lists the recorded location
          of each visitor to the show.
          You can also <CSVLink data={csvData}
              filename={filename}
              target="_blank">
              <FontAwesome name="download"/> Download the Data
            </CSVLink> as a CSV file.
        </p>
        <ReactTable
          columns={columns}
          data={this.state.locations}
          pivotBy={['postal']}
          sortable
          />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/report-list/visitor-locations-report.js